import { historyFolder } from "./historyFolder.js";

export function toHistoryKey(request: { contactId: string }): string {
  return `${historyFolder}/${request.contactId}.json`;
}
